import { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
// import { API } from "../api";
import { API, BASE_URL } from "../api";
// ─── MOCK API (mirrors Node routes) ──────────────────────────
// const API_BASE = "http://localhost:5000/api";
// const API_BASE = "http://192.168.0.57:5000/api";
const mockData = {
  settings: { engine_type: 1, site_name: "Orisnz-Fleet", minimum_rent_days: 1 },
  banners: [
    { id: 1, heading: "Drive in Style", subheading: "Premium vehicles at unbeatable prices", cta: "Book Now", image: "https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=1600&q=80" },
    { id: 2, heading: "Adventure Awaits", subheading: "Explore every destination with confidence", cta: "Explore Fleet", image: "https://images.unsplash.com/photo-1494976388531-d1058494cdd8?w=1600&q=80" },
    { id: 3, heading: "Luxury Redefined", subheading: "Experience the road like never before", cta: "View Offers", image: "https://images.unsplash.com/photo-1542362567-b07e54358753?w=1600&q=80" },
  ],
  carGroups: [
    { group_id: 1, group_name: "Small Car" },
    { group_id: 2, group_name: "SUV" },
    { group_id: 3, group_name: "Luxury" },
    { group_id: 4, group_name: "7 Seater" },
  ],
  attractions: [
    { id: 1, title: "Mountain Escapes", description: "Wind through scenic highland passes with the perfect road companion.", image: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800&q=80", tag: "Nature" },
    { id: 2, title: "Coastal Drives", description: "Sun, sea, and open roads — make every kilometre unforgettable.", image: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=800&q=80", tag: "Beach" },
    { id: 3, title: "City Exploration", description: "Navigate urban landscapes with our compact and stylish city cars.", image: "https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?w=800&q=80", tag: "Urban" },
    { id: 4, title: "Desert Trails", description: "Conquer golden dunes and vast arid terrain in our 4×4 fleet.", image: "https://images.unsplash.com/photo-1509316785289-025f5b846b35?w=800&q=80", tag: "Adventure" },
  ],
  whychoose: [
    { id: 1, icon: "🛡️", title: "Fully Insured", desc: "Every rental includes comprehensive insurance coverage for total peace of mind." },
    { id: 2, icon: "⏱️", title: "24/7 Support", desc: "Our dedicated team is available around the clock, wherever your journey takes you." },
    { id: 3, icon: "💰", title: "Best Price", desc: "We match any competitor price — premium quality without the premium cost." },
    { id: 4, icon: "🚗", title: "Premium Fleet", desc: "From economical hatchbacks to executive SUVs — a car for every occasion." },
    { id: 5, icon: "📱", title: "Easy Booking", desc: "Book in under 2 minutes via our app, website, or phone — your choice." },
    { id: 6, icon: "🌍", title: "Wide Coverage", desc: "150+ pickup locations across the region with one-way options available." },
  ],
  vehicles: [
    { id: 1, name: "Tesla Model S", category: "Electric", seats: 5, fuel: "Electric", price: 89, image: "https://images.unsplash.com/photo-1560958089-b8a1929cea89?w=600&q=80", badge: "Popular" },
    { id: 2, name: "BMW X5", category: "SUV", seats: 7, fuel: "Diesel", price: 110, image: "https://images.unsplash.com/photo-1555215695-3004980ad54e?w=600&q=80", badge: "Luxury" },
    { id: 3, name: "Toyota Corolla", category: "Sedan", seats: 5, fuel: "Petrol", price: 45, image: "https://images.unsplash.com/photo-1621007947382-bb3c3994e3fb?w=600&q=80", badge: "Economy" },
    { id: 4, name: "Jeep Wrangler", category: "4×4", seats: 5, fuel: "Petrol", price: 75, image: "https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=600&q=80", badge: "Off-Road" },
    { id: 5, name: "Mercedes GLA", category: "Compact SUV", seats: 5, fuel: "Petrol", price: 95, image: "https://images.unsplash.com/photo-1618843479313-40f8afb4b4d8?w=600&q=80", badge: "New" },
    { id: 6, name: "VW Polo", category: "Hatchback", seats: 5, fuel: "Petrol", price: 35, image: "https://images.unsplash.com/photo-1541899481282-d53bffe3c35d?w=600&q=80", badge: "Budget" },
  ],
  testimonials: [
    { id: 1, name: "Priya Sharma", location: "Mumbai", rating: 5, text: "Absolutely seamless experience from booking to return. The Tesla Model S was immaculate and the service was world-class.", avatar: "https://i.pravatar.cc/80?img=47" },
    { id: 2, name: "Arjun Mehta", location: "Delhi", rating: 5, text: "Picked up a BMW X5 for a weekend trip to the hills — it was perfect. Friendly staff and zero hidden charges.", avatar: "https://i.pravatar.cc/80?img=52" },
    { id: 3, name: "Sonia D'Souza", location: "Bangalore", rating: 5, text: "I travel for work every month and Orisnz-Fleet is the only rental I trust. Consistent quality every single time.", avatar: "https://i.pravatar.cc/80?img=44" },
    { id: 4, name: "Rahul Verma", location: "Pune", rating: 4, text: "Great fleet of vehicles at competitive prices. The booking engine is super easy to use. Will definitely be back!", avatar: "https://i.pravatar.cc/80?img=59" },
  ],
  footer: {
    company: "Orisnz-Fleet Car Rentals Pvt. Ltd.",
    address: "48 Commerce Park, Bhubaneswar, Odisha 751001",
    phone: "+91 98765 43210",
    email: "hello@Orisnz-Fleet.in",
    social: { facebook: "#", twitter: "#", instagram: "#", youtube: "#" },
    links: {
      company: ["About Us", "Careers", "Press", "Partners"],
      services: ["Long Term Rental", "Corporate Plans", "Airport Transfers", "Chauffeur Service"],
      support: ["FAQ", "Contact Us", "Terms & Conditions", "Privacy Policy"],
    },
  },
};


function useFetch(endpoint, mockKey) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    API.get(endpoint)
      .then(r => {
        const d = r.data;           // ← axios puts response here
        if (Array.isArray(d))            setData(d);
        else if (Array.isArray(d?.data)) setData(d.data);
        else if (typeof d === 'object')  setData(d);
        else                             setData(mockData[mockKey]);
        setLoading(false);
      })
      .catch(() => { setData(mockData[mockKey]); setLoading(false); });
  }, [endpoint]);

  return { data, loading };
}

// ─── STYLES ───────────────────────────────────────────────────
const css = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;900&family=DM+Sans:wght@300;400;500;600&display=swap');

  :root {
    --gold: #C9A84C;
    --gold-light: #E8C97A;
    --dark: #0A0A0F;
    --dark2: #111118;
    --dark3: #1A1A24;
    --surface: #16161F;
    --border: rgba(201,168,76,0.18);
    --text: #E8E8F0;
    --muted: #7A7A9A;
    --white: #FFFFFF;
    --radius: 12px;
  }

  * { margin:0; padding:0; box-sizing:border-box; }
  html { scroll-behavior:smooth; }
  body { font-family:'DM Sans',sans-serif; background:var(--dark); color:var(--text); overflow-x:hidden; }

  /* ── NAV ── */
  .nav {
    position:fixed; top:0; left:0; right:0; z-index:1000;
    display:flex; align-items:center; justify-content:space-between;
    padding:0 5%; height:72px;
    background:rgba(10,10,15,0.92); backdrop-filter:blur(18px);
    border-bottom:1px solid var(--border);
    transition:background .3s;
  }
  .nav-logo { font-family:'Playfair Display',serif; font-size:1.6rem; color:var(--gold); letter-spacing:-0.5px; cursor:pointer; flex-shrink:0; }
  .nav-logo span { color:var(--white); }
  .nav-links { display:flex; gap:2rem; list-style:none; }
  .nav-links a { color:var(--muted); text-decoration:none; font-size:.9rem; font-weight:500; letter-spacing:.5px; transition:color .2s; }
  .nav-links a:hover { color:var(--gold); }
  .nav-cta { background:var(--gold); color:var(--dark); font-weight:600; font-size:.85rem; padding:.55rem 1.4rem; border:none; border-radius:8px; cursor:pointer; transition:background .2s; flex-shrink:0; }
  .nav-cta:hover { background:var(--gold-light); }

  /* Mobile nav menu */
  .nav-mobile-toggle {
    display:none; flex-direction:column; gap:5px; cursor:pointer;
    background:none; border:none; padding:4px;
  }
  .nav-mobile-toggle span {
    display:block; width:24px; height:2px;
    background:var(--gold); border-radius:2px; transition:all .3s;
  }
  .mobile-menu {
    display:none; position:fixed; top:72px; left:0; right:0; z-index:999;
    background:rgba(10,10,15,0.98); backdrop-filter:blur(18px);
    border-bottom:1px solid var(--border);
    padding:1.5rem 5%; flex-direction:column; gap:0;
  }
  .mobile-menu.open { display:flex; }
  .mobile-menu a {
    color:var(--muted); text-decoration:none; font-size:1rem;
    font-weight:500; padding:.9rem 0;
    border-bottom:1px solid var(--border);
    transition:color .2s; display:block;
  }
  .mobile-menu a:hover { color:var(--gold); }
  .mobile-menu .nav-cta { margin-top:1rem; width:100%; text-align:center; padding:.7rem; font-size:.95rem; }

  /* ── HERO / BANNER ── */
  .banner { position:relative; height:100vh; overflow:hidden; }
  .banner-slide { position:absolute; inset:0; transition:opacity .9s ease, transform 1.2s ease; opacity:0; transform:scale(1.05); }
  .banner-slide.active { opacity:1; transform:scale(1); }
  .banner-img { width:100%; height:100%; object-fit:cover; }
  .banner-overlay { position:absolute; inset:0; background:linear-gradient(135deg,rgba(10,10,15,.85) 0%,rgba(10,10,15,.4) 60%,transparent 100%); }
  .banner-content { position:absolute; bottom:18%; left:8%; max-width:600px; right:8%; }
  .banner-tag { font-size:.75rem; letter-spacing:3px; color:var(--gold); text-transform:uppercase; margin-bottom:1rem; }
  .banner-heading { font-family:'Playfair Display',serif; font-size:clamp(2.2rem,6vw,5.5rem); line-height:1.05; color:var(--white); margin-bottom:1.2rem; }
  .banner-sub { font-size:clamp(.9rem,2vw,1.1rem); color:rgba(232,232,240,.75); margin-bottom:2.2rem; font-weight:300; }
  .banner-btn { background:var(--gold); color:var(--dark); font-weight:700; padding:.9rem 2.4rem; border:none; border-radius:8px; font-size:1rem; cursor:pointer; transition:all .25s; }
  .banner-btn:hover { background:var(--gold-light); transform:translateY(-2px); box-shadow:0 12px 40px rgba(201,168,76,.35); }
  .banner-dots { position:absolute; bottom:8%; left:8%; display:flex; gap:.5rem; }
  .banner-dot { width:30px; height:3px; background:rgba(255,255,255,.3); border:none; border-radius:2px; cursor:pointer; transition:all .3s; }
  .banner-dot.active { background:var(--gold); width:56px; }

  /* ── BOOKING ENGINE ── */
  .booking-wrap { background:var(--dark2); border-top:1px solid var(--border); border-bottom:1px solid var(--border); }

  /* Horizontal Engine */
  .be-horizontal { padding:2.2rem 5%; display:flex; gap:1rem; align-items:flex-end; flex-wrap:wrap; }
  .be-field { display:flex; flex-direction:column; flex:1; min-width:160px; gap:.4rem; }
  .be-field label { font-size:.72rem; letter-spacing:1.5px; text-transform:uppercase; color:var(--gold); font-weight:600; }
  .be-field input, .be-field select { background:var(--surface); border:1px solid var(--border); color:var(--text); padding:.75rem 1rem; border-radius:var(--radius); font-size:.9rem; font-family:inherit; appearance:none; outline:none; transition:border .2s; }
  .be-field input:focus, .be-field select:focus { border-color:var(--gold); }
  .be-search { background:var(--gold); color:var(--dark); font-weight:700; padding:.8rem 2rem; border:none; border-radius:var(--radius); font-size:.95rem; cursor:pointer; white-space:nowrap; transition:all .25s; align-self:flex-end; }
  .be-search:hover { background:var(--gold-light); }

  /* Vertical Engine */
  .be-vertical { padding:2.5rem 5%; display:flex; gap:2rem; justify-content:center; flex-wrap:wrap; }
  .be-vertical-card { background:var(--surface); border:1px solid var(--border); border-radius:16px; padding:2rem; width:320px; }
  .be-vertical-card h3 { font-family:'Playfair Display',serif; color:var(--gold); margin-bottom:1.4rem; font-size:1.2rem; }
  .be-vertical-card .be-field { margin-bottom:1rem; }
  .be-vertical-card .be-search { width:100%; margin-top:.5rem; text-align:center; }

  /* ── SECTION COMMONS ── */
  .section { padding:5rem 5%; }
  .section-label { font-size:.72rem; letter-spacing:3px; text-transform:uppercase; color:var(--gold); margin-bottom:.8rem; }
  .section-title { font-family:'Playfair Display',serif; font-size:clamp(1.8rem,4vw,3.2rem); color:var(--white); margin-bottom:1rem; line-height:1.1; }
  .section-desc { color:var(--muted); max-width:520px; line-height:1.7; font-size:.95rem; }

  /* ── WELCOME / ABOUT ── */
  .welcome { display:grid; grid-template-columns:1fr 1fr; gap:5rem; align-items:center; }
  .welcome-img-wrap { position:relative; border-radius:20px; overflow:hidden; aspect-ratio:4/3; }
  .welcome-img-wrap img { width:100%; height:100%; object-fit:cover; }
  .welcome-badge { position:absolute; bottom:1.5rem; right:-1.5rem; background:var(--gold); color:var(--dark); padding:1.2rem 1.6rem; border-radius:14px; font-family:'Playfair Display',serif; font-size:2rem; font-weight:900; line-height:1; }
  .welcome-badge span { display:block; font-family:'DM Sans',sans-serif; font-size:.75rem; font-weight:500; }
  .stats-row { display:flex; gap:2rem; margin-top:2.5rem; flex-wrap:wrap; }
  .stat { border-left:3px solid var(--gold); padding-left:1rem; }
  .stat-num { font-family:'Playfair Display',serif; font-size:1.8rem; color:var(--white); }
  .stat-label { font-size:.8rem; color:var(--muted); }

  /* ── WHY CHOOSE ── */
  .why-section { background:var(--dark2); border-top:1px solid var(--border); border-bottom:1px solid var(--border); }
  .why-grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(280px,1fr)); gap:1.5rem; margin-top:3.5rem; }
  .why-card { background:var(--surface); border:1px solid var(--border); border-radius:16px; padding:2rem; transition:all .3s; cursor:default; }
  .why-card:hover { border-color:var(--gold); transform:translateY(-4px); box-shadow:0 20px 50px rgba(0,0,0,.4); }
  .why-icon { font-size:2.4rem; margin-bottom:1rem; }
  .why-title { font-weight:700; font-size:1.05rem; color:var(--white); margin-bottom:.5rem; }
  .why-desc { font-size:.88rem; color:var(--muted); line-height:1.65; }

  /* ── ATTRACTIONS ── */
  .attr-grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(260px,1fr)); gap:1.5rem; margin-top:3.5rem; }
  .attr-card { border-radius:16px; overflow:hidden; position:relative; aspect-ratio:4/5; cursor:pointer; }
  .attr-card img { width:100%; height:100%; object-fit:cover; transition:transform .5s ease; }
  .attr-card:hover img { transform:scale(1.07); }
  .attr-overlay { position:absolute; inset:0; background:linear-gradient(to top,rgba(10,10,15,.9) 0%,transparent 55%); }
  .attr-tag { position:absolute; top:1rem; left:1rem; background:var(--gold); color:var(--dark); font-size:.72rem; font-weight:700; padding:.3rem .8rem; border-radius:20px; letter-spacing:.5px; }
  .attr-info { position:absolute; bottom:1.5rem; left:1.5rem; right:1.5rem; }
  .attr-title { font-family:'Playfair Display',serif; font-size:1.3rem; color:var(--white); margin-bottom:.4rem; }
  .attr-desc { font-size:.82rem; color:rgba(232,232,240,.7); line-height:1.5; }

  /* ── VEHICLES ── */
  .vehicles-section { background:var(--dark2); border-top:1px solid var(--border); }
  .vehicle-slider-wrap { position:relative; margin-top:3.5rem; overflow:hidden; }
  .vehicle-track { display:flex; gap:1.5rem; transition:transform .5s ease; }
  .vehicle-card { min-width:385px; background:var(--surface); border:1px solid var(--border); border-radius:16px; overflow:hidden; flex-shrink:0; transition:border-color .3s, transform .3s; }
  .vehicle-card:hover { border-color:var(--gold); transform:translateY(-4px); }
  .vehicle-img { width:100%; height:180px; object-fit:cover; }
  .vehicle-body { padding:1.4rem; }
  .vehicle-badge { display:inline-block; background:rgba(201,168,76,.15); color:var(--gold); font-size:.72rem; font-weight:700; padding:.25rem .7rem; border-radius:20px; margin-bottom:.7rem; letter-spacing:.5px; }
  .vehicle-name { font-family:'Playfair Display',serif; font-size:1.15rem; color:var(--white); margin-bottom:.3rem; }
  .vehicle-cat { font-size:.82rem; color:var(--muted); margin-bottom:1rem; }
  .vehicle-meta { display:flex; gap:.8rem; flex-wrap:wrap; margin-bottom:1.2rem; }
  .vehicle-meta span { font-size:.78rem; color:var(--muted); background:var(--dark3); padding:.25rem .6rem; border-radius:6px; }
  .vehicle-footer { display:flex; align-items:center; justify-content:space-between; }
  .vehicle-price { color:var(--gold); font-weight:700; font-size:1.1rem; }
  .vehicle-price small { color:var(--muted); font-size:.75rem; font-weight:400; }
  .vehicle-btn { background:transparent; color:var(--gold); border:1px solid var(--gold); font-size:.8rem; font-weight:600; padding:.4rem 1rem; border-radius:8px; cursor:pointer; transition:all .2s; }
  .vehicle-btn:hover { background:var(--gold); color:var(--dark); }
  .slider-nav { display:flex; gap:.7rem; justify-content:center; margin-top:2rem; flex-wrap:wrap; }
  .sl-btn { width:44px; height:44px; border-radius:50%; background:var(--surface); border:1px solid var(--border); color:var(--text); font-size:1.1rem; cursor:pointer; transition:all .2s; }
  .sl-btn:hover { background:var(--gold); color:var(--dark); border-color:var(--gold); }

  /* ── TESTIMONIALS ── */
  .testi-section { padding:6rem 5%; }
  .testi-track-wrap { overflow:hidden; margin-top:3.5rem; }
  .testi-track { display:flex; gap:1.5rem; transition:transform .5s ease; }
  .testi-card { min-width:340px; background:var(--surface); border:1px solid var(--border); border-radius:16px; padding:2rem; flex-shrink:0; }
  .testi-stars { color:var(--gold); font-size:1rem; letter-spacing:2px; margin-bottom:1rem; }
  .testi-text { font-size:.93rem; color:var(--text); line-height:1.7; font-style:italic; margin-bottom:1.5rem; }
  .testi-person { display:flex; align-items:center; gap:1rem; }
  .testi-avatar { width:48px; height:48px; border-radius:50%; object-fit:cover; border:2px solid var(--gold); }
  .testi-name { font-weight:600; font-size:.95rem; color:var(--white); }
  .testi-loc { font-size:.8rem; color:var(--muted); }

  /* ── FOOTER ── */
  footer { background:var(--dark2); border-top:1px solid var(--border); padding:5rem 5% 2rem; }
  .footer-top { display:grid; grid-template-columns:1.5fr 1fr 1fr 1fr; gap:3rem; margin-bottom:3.5rem; }
  .footer-brand { font-family:'Playfair Display',serif; font-size:1.8rem; color:var(--gold); margin-bottom:.8rem; }
  .footer-brand span { color:var(--white); }
  .footer-tagline { font-size:.88rem; color:var(--muted); line-height:1.6; margin-bottom:1.5rem; }
  .footer-contact p { font-size:.85rem; color:var(--muted); margin-bottom:.4rem; }
  .footer-contact strong { color:var(--text); }
  .footer-social { display:flex; gap:.7rem; margin-top:1.2rem; flex-wrap:wrap; }
  .social-btn { width:36px; height:36px; border-radius:8px; background:var(--surface); border:1px solid var(--border); color:var(--muted); display:flex; align-items:center; justify-content:center; font-size:.85rem; cursor:pointer; transition:all .2s; text-decoration:none; }
  .social-btn:hover { background:var(--gold); color:var(--dark); border-color:var(--gold); }
  .footer-col h4 { font-size:.8rem; letter-spacing:2px; text-transform:uppercase; color:var(--gold); margin-bottom:1.2rem; font-weight:600; }
  .footer-col ul { list-style:none; }
  .footer-col li { margin-bottom:.6rem; }
  .footer-col a { color:var(--muted); text-decoration:none; font-size:.88rem; transition:color .2s; }
  .footer-col a:hover { color:var(--gold); }
  .footer-bottom { border-top:1px solid var(--border); padding-top:1.5rem; display:flex; justify-content:space-between; align-items:center; flex-wrap:wrap; gap:1rem; }
  .footer-bottom p { font-size:.8rem; color:var(--muted); }

  /* ── UTILS ── */
  .gold { color:var(--gold); }
  .flex-between { display:flex; justify-content:space-between; align-items:flex-end; flex-wrap:wrap; gap:1rem; }

  select option { background:#1f1f26; }

  /* ═══════════════════════════════════════════════
     RESPONSIVE BREAKPOINTS
  ═══════════════════════════════════════════════ */

  /* ── LARGE TABLET / SMALL DESKTOP (≤1024px) ── */
  @media (max-width:1024px) {
    .welcome { gap:3rem; }
    .footer-top { grid-template-columns:1fr 1fr; gap:2rem; }
    .vehicle-card { min-width:260px; }
  }

  /* ── TABLET (≤768px) ── */
  @media (max-width:768px) {
    /* Nav */
    .nav { padding:0 4%; height:64px; }
    .nav-logo { font-size:1.35rem; }
    .nav-links { display:none; }
    .nav-mobile-toggle { display:flex; }
    .nav-cta { display:none; }

    /* Banner */
    .banner { height:70vh; min-height:420px; }
    .banner-content { bottom:15%; left:5%; right:5%; }
    .banner-dots { bottom:6%; left:5%; }

    /* Sections */
    .section { padding:4rem 4%; }

    /* Welcome */
    .welcome { grid-template-columns:1fr; gap:2.5rem; }
    .welcome-badge { right:1rem; bottom:1rem; font-size:1.5rem; padding:1rem 1.2rem; }
    .stats-row { gap:1.5rem; }
    .stat-num { font-size:1.5rem; }

    /* Attractions — 2 cols on tablet */
    .attr-grid { grid-template-columns:repeat(2, 1fr); gap:1rem; }

    /* Vehicle slider — show 1 card on tablet */
    .vehicle-card { min-width:calc(100vw - 8% - 24px); }

    /* Why grid — 2 cols */
    .why-grid { grid-template-columns:repeat(2,1fr); gap:1rem; }

    /* Footer */
    .footer-top { grid-template-columns:1fr 1fr; gap:2rem; }
    .footer-brand { font-size:1.5rem; }
  }

  /* ── MOBILE LARGE (≤600px) ── */
  @media (max-width:600px) {
    /* Nav */
    .nav { padding:0 4%; }
    .nav-logo { font-size:1.2rem; }

    /* Banner */
    .banner { height:60vh; min-height:360px; }
    .banner-content { bottom:18%; }
    .banner-btn { padding:.75rem 1.8rem; font-size:.9rem; }

    /* Sections */
    .section { padding:3.5rem 4%; }

    /* Attractions — stack to 1 col */
    .attr-grid { grid-template-columns:1fr; }
    .attr-card { aspect-ratio:16/9; }

    /* Why grid — 1 col */
    .why-grid { grid-template-columns:1fr; }

    /* Vehicles — full width */
    .vehicle-card { min-width:calc(100vw - 8%); }

    /* Stats — wrap nicely */
    .stats-row { gap:1rem; }
    .stat { min-width:calc(50% - 1rem); }

    /* flex-between stacks */
    .flex-between { flex-direction:column; align-items:flex-start; }

    /* Footer — single col */
    .footer-top { grid-template-columns:1fr; gap:2rem; }
    .footer-bottom { flex-direction:column; text-align:center; }
  }

  /* ── MOBILE SMALL (≤400px) ── */
  @media (max-width:400px) {
    .nav { padding:0 3.5%; }
    .nav-logo { font-size:1.1rem; }
    .section { padding:3rem 3.5%; }
    .banner-heading { font-size:clamp(1.7rem,8vw,2.5rem); }
    .banner-content { left:4%; right:4%; }
    .banner-dots { left:4%; }
    .section-title { font-size:clamp(1.5rem,7vw,2rem); }
    .why-card { padding:1.5rem; }
    .vehicle-body { padding:1rem; }
    .footer-top { gap:1.5rem; }
    .sl-btn { width:38px; height:38px; font-size:.9rem; }
    .stat { min-width:calc(50% - .5rem); }
    .stats-row { gap:.75rem; }
    .welcome-badge { font-size:1.2rem; padding:.8rem 1rem; right:.5rem; }
  }
`;

// ─── SUB-COMPONENTS ─────────────────────────────────────────

// function Navbar({ siteName }) {
//   const [menuOpen, setMenuOpen] = useState(false);
//   const navigate = useNavigate();

//   // Map label → route (null = anchor on the same page)
//   const NAV_LINKS = [
//     { label: "Home",        href: "/" },
//     { label: "Fleet",       href: "/our-cars" },   // ← NEW route
//     { label: "Modify Reservation ",       href: "/modify-reservetion" },   
//     // { label: "Attractions", href: null },
//     { label: "About",       href: "/about-us" },
//     { label: "Gallery",       href: "/gallery" },
//     { label: "Faq",       href: "/faqs" },
//     { label: "Contact",     href: "/contact-us" },
//   ];

//   const handleNav = (link) => {
//     if (link.href) {
//       navigate(link.href);
//     }
//     setMenuOpen(false);
//   };

//   return (
//     <>
//       <nav className="nav">
//         <div className="nav-logo" onClick={() => navigate("/")}>
//           Orisnz<span>{siteName?.replace("Drive", "") || "-Fleet"}</span>
//         </div>

//         {/* Desktop links */}
//         <ul className="nav-links">
//           {NAV_LINKS.map(l => (
//             <li key={l.label}>
//               <a
//                 href={l.href || "#"}
//                 onClick={l.href ? (e) => { e.preventDefault(); handleNav(l); } : undefined}
//               >
//                 {l.label}
//               </a>
//             </li>
//           ))}
//         </ul>

//         <button className="nav-cta">
//           <a href="#bknengine" style={{ textDecoration: "none", color: "#000" }}>
//             Book Now
//           </a>
//         </button>

//         {/* Mobile toggle */}
//         <button
//           className="nav-mobile-toggle"
//           onClick={() => setMenuOpen(o => !o)}
//           aria-label="Toggle menu"
//         >
//           <span style={menuOpen ? { transform: "rotate(45deg) translate(5px,5px)" } : {}} />
//           <span style={menuOpen ? { opacity: 0 } : {}} />
//           <span style={menuOpen ? { transform: "rotate(-45deg) translate(5px,-5px)" } : {}} />
//         </button>
//       </nav>

//       {/* Mobile dropdown */}
//       <div className={`mobile-menu${menuOpen ? " open" : ""}`}>
//         {NAV_LINKS.map(l => (
//           <a
//             key={l.label}
//             href={l.href || "#"}
//             onClick={(e) => { if (l.href) { e.preventDefault(); handleNav(l); } else setMenuOpen(false); }}
//           >
//             {l.label}
//           </a>
//         ))}
//         <button className="nav-cta" onClick={() => setMenuOpen(false)}>Book Now</button>
//       </div>
//     </>
//   );
// }

function BannerSlider({ slides }) {
  const [active, setActive] = useState(0);

  useEffect(() => {
    if (!slides?.length) return;
    const t = setInterval(() => setActive(i => (i + 1) % slides.length), 5000);
    return () => clearInterval(t);
  }, [slides?.length]);

  if (!slides?.length) return null;

  const getImg = (slide) => {
    if (slide.banner_img && slide.banner_img !== 'default.jpg')
      // return `${API_BASE}/img/banner/${slide.banner_img}`;
      return `${BASE_URL}/img/banner/${slide.banner_img}`;
    return "https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=1600&q=80";
  };

  return (
    <section className="banner">
      {slides.map((s, i) => (
        <div key={s.banner_id ?? i} className={`banner-slide${i === active ? " active" : ""}`}>
          <img src={getImg(s)} alt={s.bimage_alt || s.banner_name || "Banner"} className="banner-img" />
          <div className="banner-overlay" />
        </div>
      ))}
      <div className="banner-content">
        <div className="banner-tag">Premium Car Rental</div>
        <h1 className="banner-heading">{slides[active]?.banner_name}</h1>
        <p className="banner-sub">Experience the road like never before</p>
        <button className="banner-btn">Book Now</button>
      </div>
      <div className="banner-dots">
        {slides.map((_, i) => (
          <button key={i} className={`banner-dot${i === active ? " active" : ""}`} onClick={() => setActive(i)} />
        ))}
      </div>
    </section>
  );
}

// ── SHARED BOOKING FORM (UNCHANGED)
function BookingForm({ layout = "horizontal" }) {
  const location = useLocation();
  const navigate = useNavigate();
  const data = location.state || {};

  const [pickup, setPickup]         = useState(data.pickup || "");
  const [dropoff, setDropoff]       = useState(data.dropoff || "");
  const [pickupDate, setPickupDate] = useState(data.pickupDate || "");
  const [returnDate, setReturnDate] = useState(data.returnDate || "");
  const [pickupTime, setPickupTime] = useState(data.pickupTime || "10:00");
  const [returnTime, setReturnTime] = useState(data.returnTime || "10:00");
  const [driverAge, setDriverAge]   = useState(data.driverAge || "");
  const [diffDrop, setDiffDrop]     = useState(data.diffDrop || false);
  const [locations, setLocations]   = useState([]);   // ← NEW

  // Sync state when navigating back with existing state
  useEffect(() => {
    if (location.state) {
      setPickup(location.state.pickup || "");
      setDropoff(location.state.dropoff || "");
      setPickupDate(location.state.pickupDate || "");
      setReturnDate(location.state.returnDate || "");
      setPickupTime(location.state.pickupTime || "10:00");
      setReturnTime(location.state.returnTime || "10:00");
      setDriverAge(location.state.driverAge || "");
      setDiffDrop(location.state.diffDrop || false);
    }
  }, [location.state]);

  // Fetch locations from API  ← NEW
  useEffect(() => {
    // fetch(`${API_BASE}/locations`)
    API.get("/locations")
  .then(r => {
    const d = r.data;
    const list = Array.isArray(d) ? d : (Array.isArray(d?.data) ? d.data : []);
    setLocations(list);
  })
  .catch(() => setLocations([]));
  }, []);

  const today = new Date().toISOString().split("T")[0];
  const isH   = layout === "horizontal";

  const timeOptions = Array.from({ length: 24 }, (_, i) =>
    `${String(i).padStart(2, "0")}:00`
  );

  const calcDays = () => {
    if (!pickupDate || !returnDate) return null;
    const [py, pm, pd] = pickupDate.split("-").map(Number);
    const [ry, rm, rd] = returnDate.split("-").map(Number);
    const start = new Date(py, pm - 1, pd);
    const end   = new Date(ry, rm - 1, rd);
    const diff  = Math.round((end - start) / (1000 * 60 * 60 * 24));
    return diff > 0 ? diff : null;
  };

  const labelStyle = {
    fontSize: ".68rem", letterSpacing: "1.8px",
    textTransform: "uppercase", color: "var(--gold)",
    fontWeight: 700, marginBottom: ".35rem", display: "block",
  };

  const inputStyle = {
    background: "rgba(255,255,255,.06)",
    border: "1px solid rgba(201,168,76,.25)",
    color: "var(--text)", padding: ".7rem .9rem",
    borderRadius: "8px", fontSize: ".88rem",
    fontFamily: "inherit", outline: "none",
    width: "100%", transition: "border .2s",
  };

  const selectStyle = { ...inputStyle, cursor: "pointer", appearance: "none" };

  const handleSearch = () => {
    if (!pickup)     return alert("Select a pickup location");
    if (!pickupDate) return alert("Select pickup date");
    if (!returnDate) return alert("Select return date");
    if (!driverAge)  return alert("Select driver age");

    navigate("/booking-step2", {
      state: {
        pickup,
        dropoff: diffDrop ? dropoff : pickup,
        pickupDate, returnDate, pickupTime, returnTime, driverAge, diffDrop,
      }
    });
  };

  // Reusable location select element
  const LocationSelect = ({ value, onChange, placeholder }) => (
    <select value={value} onChange={e => onChange(e.target.value)} style={selectStyle}>
      <option value="">{placeholder}</option>
      {locations.map(loc => (
        <option key={loc.loc_id} value={loc.loc_name}>
          {loc.loc_name}{loc.city_name ? ` — ${loc.city_name}` : ""}
        </option>
      ))}
    </select>
  );

  // ── HORIZONTAL LAYOUT ──────────────────────────────────────
  if (isH) {
    return (
      <div id="bknengine" style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
        <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap" }}>
          <div style={{ flex: "1", minWidth: "200px" }}>
            <label style={labelStyle}>Pickup Location</label>
            <LocationSelect
              value={pickup}
              onChange={setPickup}
              placeholder="Select pickup location..."
            />
            <label style={{
              display: "flex", alignItems: "center", gap: ".4rem",
              fontSize: ".76rem", color: "var(--muted)",
              cursor: "pointer", marginTop: ".45rem"
            }}>
              <input
                type="checkbox" checked={diffDrop}
                onChange={e => setDiffDrop(e.target.checked)}
                style={{ accentColor: "var(--gold)", width: 13, height: 13, cursor: "pointer" }}
              />
              Drop off at a different location?
            </label>
          </div>

          {diffDrop && (
            <div style={{ flex: "1", minWidth: "200px" }}>
              <label style={labelStyle}>Drop-off Location</label>
              <LocationSelect
                value={dropoff}
                onChange={setDropoff}
                placeholder="Select drop-off location..."
              />
            </div>
          )}
        </div>

        <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap", alignItems: "flex-end" }}>
          <div style={{ flex: "1.5", minWidth: "220px" }}>
            <label style={labelStyle}>Pickup Date & Time</label>
            <div style={{ display: "flex", gap: ".5rem" }}>
              <input
                type="date" min={today} value={pickupDate}
                onChange={e => {
                  setPickupDate(e.target.value);
                  if (!returnDate || returnDate <= e.target.value) {
                    const next = new Date(e.target.value);
                    next.setDate(next.getDate() + 1);
                    setReturnDate(next.toISOString().split("T")[0]);
                  }
                }}
                style={{ ...inputStyle, flex: 2 }}
              />
              <select value={pickupTime} onChange={e => setPickupTime(e.target.value)} style={{ ...selectStyle, flex: 1 }}>
                {timeOptions.map(t => <option key={t}>{t}</option>)}
              </select>
            </div>
          </div>

          <div style={{ flex: "1.5", minWidth: "220px" }}>
            <label style={labelStyle}>Return Date & Time</label>
            <div style={{ display: "flex", gap: ".5rem" }}>
              <input
                type="date" min={pickupDate || today} value={returnDate}
                onChange={e => setReturnDate(e.target.value)}
                style={{ ...inputStyle, flex: 2 }}
              />
              <select value={returnTime} onChange={e => setReturnTime(e.target.value)} style={{ ...selectStyle, flex: 1 }}>
                {timeOptions.map(t => <option key={t}>{t}</option>)}
              </select>
            </div>
          </div>

          <div style={{ flex: "1", minWidth: "150px" }}>
            <label style={labelStyle}>Driver Age (Min 21)</label>
            <select value={driverAge} onChange={e => setDriverAge(e.target.value)} style={selectStyle}>
              <option value="">Select age</option>
              <option value="21-25">21 – 25 yrs</option>
              <option value="26-35">26 – 35 yrs</option>
              <option value="36-45">36 – 45 yrs</option>
              <option value="46-60">46 – 60 yrs</option>
              <option value="61-70">61 – 70 yrs</option>
              <option value="71+">71+ yrs</option>
            </select>
            {driverAge === "21-25" && (
              <span style={{ fontSize: ".7rem", color: "#EF9F27", marginTop: ".3rem", display: "block" }}>
                ⚠️ Young driver surcharge may apply
              </span>
            )}
          </div>

          {calcDays() && (
            <div style={{ alignSelf: "flex-end" }}>
              <div style={{
                background: "rgba(201,168,76,.12)", border: "1px solid var(--gold)",
                borderRadius: "8px", padding: ".68rem 1rem",
                fontSize: ".82rem", color: "var(--gold)", fontWeight: 700,
                whiteSpace: "nowrap", textAlign: "center"
              }}>
                {calcDays()} day{calcDays() > 1 ? "s" : ""}
              </div>
            </div>
          )}

          <button
            onClick={handleSearch}
            style={{
              background: "var(--gold)", color: "var(--dark)",
              fontWeight: 700, padding: ".7rem 2rem",
              border: "none", borderRadius: "8px",
              fontSize: ".95rem", cursor: "pointer",
              whiteSpace: "nowrap", alignSelf: "flex-end",
              transition: "background .2s",
            }}
            onMouseEnter={e => e.currentTarget.style.background = "var(--gold-light)"}
            onMouseLeave={e => e.currentTarget.style.background = "var(--gold)"}
          >
            Search →
          </button>
        </div>
      </div>
    );
  }

  // ── VERTICAL LAYOUT ────────────────────────────────────────
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
      <div>
        <label style={labelStyle}>Pickup Location</label>
        <LocationSelect
          value={pickup}
          onChange={setPickup}
          placeholder="Select pickup location..."
        />
        <label style={{
          display: "flex", alignItems: "center", gap: ".4rem",
          fontSize: ".76rem", color: "var(--muted)",
          cursor: "pointer", marginTop: ".45rem"
        }}>
          <input
            type="checkbox" checked={diffDrop}
            onChange={e => setDiffDrop(e.target.checked)}
            style={{ accentColor: "var(--gold)", width: 13, height: 13, cursor: "pointer" }}
          />
          Drop off at a different location?
        </label>
      </div>

      {diffDrop && (
        <div>
          <label style={labelStyle}>Drop-off Location</label>
          <LocationSelect
            value={dropoff}
            onChange={setDropoff}
            placeholder="Select drop-off location..."
          />
        </div>
      )}

      <div>
        <label style={labelStyle}>Pickup Date & Time</label>
        <div style={{ display: "flex", gap: ".5rem" }}>
          <input
            type="date" min={today} value={pickupDate}
            onChange={e => {
              setPickupDate(e.target.value);
              if (!returnDate || returnDate <= e.target.value) {
                const next = new Date(e.target.value);
                next.setDate(next.getDate() + 1);
                setReturnDate(next.toISOString().split("T")[0]);
              }
            }}
            style={{ ...inputStyle, flex: 2 }}
          />
          <select value={pickupTime} onChange={e => setPickupTime(e.target.value)} style={{ ...selectStyle, flex: 1 }}>
            {timeOptions.map(t => <option key={t}>{t}</option>)}
          </select>
        </div>
      </div>

      <div>
        <label style={labelStyle}>Return Date & Time</label>
        <div style={{ display: "flex", gap: ".5rem" }}>
          <input
            type="date" min={pickupDate || today} value={returnDate}
            onChange={e => setReturnDate(e.target.value)}
            style={{ ...inputStyle, flex: 2 }}
          />
          <select value={returnTime} onChange={e => setReturnTime(e.target.value)} style={{ ...selectStyle, flex: 1 }}>
            {timeOptions.map(t => <option key={t}>{t}</option>)}
          </select>
        </div>
      </div>

      <div>
        <label style={labelStyle}>Driver Age (Min 21)</label>
        <select value={driverAge} onChange={e => setDriverAge(e.target.value)} style={selectStyle}>
          <option value="">Select age range</option>
          <option value="21-25">21 – 25 years</option>
          <option value="26-35">26 – 35 years</option>
          <option value="36-45">36 – 45 years</option>
          <option value="46-60">46 – 60 years</option>
          <option value="61-70">61 – 70 years</option>
          <option value="71+">71+ years</option>
        </select>
        {driverAge === "21-25" && (
          <span style={{ fontSize: ".72rem", color: "#EF9F27", marginTop: ".3rem", display: "block" }}>
            ⚠️ Young driver surcharge may apply
          </span>
        )}
      </div>

      <div style={{ display: "flex", gap: ".75rem", alignItems: "center", marginTop: ".25rem" }}>
        {calcDays() && (
          <div style={{
            background: "rgba(201,168,76,.12)", border: "1px solid var(--gold)",
            borderRadius: "8px", padding: ".65rem 1rem",
            fontSize: ".82rem", color: "var(--gold)", fontWeight: 700, whiteSpace: "nowrap",
          }}>
            {calcDays()} day{calcDays() > 1 ? "s" : ""}
          </div>
        )}
        <button
          onClick={handleSearch}
          style={{
            flex: 1, background: "var(--gold)", color: "var(--dark)",
            fontWeight: 700, padding: ".78rem",
            border: "none", borderRadius: "8px",
            fontSize: ".95rem", cursor: "pointer", transition: "background .2s",
          }}
          onMouseEnter={e => e.currentTarget.style.background = "var(--gold-light)"}
          onMouseLeave={e => e.currentTarget.style.background = "var(--gold)"}
        >
          Search Vehicles →
        </button>
      </div>
    </div>
  );
}

function BookingEngineHorizontal({ carGroups }) {
  return (
    <div style={{
      background: "var(--dark2)",
      borderTop: "1px solid var(--border)",
      borderBottom: "1px solid var(--border)",
      padding: "2rem 5%",
    }}>
      <BookingForm layout="horizontal" />
    </div>
  );
}

function BookingEngineVertical({ carGroups }) {
  return (
    <div style={{
      background: "var(--dark2)",
      borderTop: "1px solid var(--border)",
      borderBottom: "1px solid var(--border)",
      padding: "3rem 5%",
      display: "flex",
      justifyContent: "center",
    }}>
      <div style={{
        background: "var(--surface)",
        border: "1px solid var(--border)",
        borderRadius: "16px",
        padding: "2rem",
        width: "100%",
        maxWidth: "460px",
      }}>
        <h3 style={{
          fontFamily: "'Playfair Display',serif",
          color: "var(--gold)",
          fontSize: "1.3rem",
          marginBottom: "1.5rem",
          paddingBottom: ".8rem",
          borderBottom: "1px solid var(--border)",
        }}>
          Book Your Vehicle
        </h3>
        <BookingForm layout="vertical" />
      </div>
    </div>
  );
}

function WelcomeSection() {
  const [content, setContent] = useState(null);
  const [section, setSection] = useState(null);

  const decodeHTML = (str) => {
    if (!str) return "";
    const txt = document.createElement("textarea");
    txt.innerHTML = str;
    return txt.value;
  };

  useEffect(() => {
    // ✅ pagemaster.php = cont_id 39 = "Welcome To Car Rental Mauritius"
    // fetch(`${API_BASE}/contents/bypage?page_name=pagemaster.php`)
    // fetch(`${API_BASE}/contents/bypage?page_name=pagemaster.php`)
    API.get("/contents/bypage?page_name=pagemaster.php")
  .then(r => {
    const rows = Array.isArray(r.data) ? r.data : (r.data?.data || []);
    setContent(rows[0] || null);
  })
  .catch(() => {});

    // fetch(`${API_BASE}/defaultsection?section_name=welcome`)
    API.get("/defaultsection?section_name=welcome")
  .then(r => {
    const rows = Array.isArray(r.data) ? r.data : (r.data?.data || []);
    setSection(rows[0] || null);
  })
  .catch(() => {});
  }, []);

  const sectionLabel = section?.heading    || "Welcome to Orisnz-Fleet";
  const mainTitle    = content?.cont_title || "Your Journey, Our Passion";
  const bodyHTML     = decodeHTML(content?.cont_details) ||
                       "Since 2010, Orisnz-Fleet has been redefining car rental across India.";

  const imgSrc = content?.cont_img && content.cont_img !== "NULL" && content.cont_img !== null
    // ? `${API_BASE}/img/contents/${content.cont_img}`
    ? `${BASE_URL}/img/contents/${content.cont_img}`
    : "https://images.unsplash.com/photo-1568605117036-5fe5e7bab0b7?w=800&q=80";

  return (
    <section className="section">
      <div className="welcome">
        <div className="welcome-img-wrap">
          <img src={imgSrc} alt={mainTitle} />
          <div className="welcome-badge">
            15+<span>Years of Excellence</span>
          </div>
        </div>
        <div>
          <div className="section-label">{sectionLabel}</div>
          <h2
            className="section-title"
            dangerouslySetInnerHTML={{
              __html: mainTitle.replace(
                /(Car Rental \w+|Mauritius|Our \w+|Passion|Excellence)/gi,
                '<span class="gold">$1</span>'
              )
            }}
          />
          <div
            className="section-desc"
            style={{ marginBottom: "1.2rem", lineHeight: 1.7 }}
            dangerouslySetInnerHTML={{ __html: bodyHTML }}
          />
          <div className="stats-row">
            {[
              ["50K+", "Happy Customers"],
              ["150+", "Pickup Points"],
              ["500+", "Vehicles"],
              ["4.9★", "Avg Rating"],
            ].map(([n, l]) => (
              <div className="stat" key={l}>
                <div className="stat-num">{n}</div>
                <div className="stat-label">{l}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

function WhyChooseSection({ items }) {
  const grouped = (items || [])
    .filter(s => s.section_status === 1)
    .reduce((acc, item) => {
      const key = item.section_name?.toLowerCase().trim();
      if (!acc[key]) acc[key] = [];
      acc[key].push(item);
      return acc;
    }, {});

  const sectionGroups = Object.entries(grouped);
  if (!sectionGroups.length) return null;

  const arrowColors = ["#378ADD", "#1D9E75", "#BA7517"];

  return (
    <section className="section why-section">
      <div style={{ textAlign: "center", marginBottom: "2rem" }}>
        <div className="section-label">Our Promise</div>
        <h2 className="section-title">Everything You <span className="gold">Need</span></h2>
      </div>
      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
        gap: "1.5rem"
      }}>
        {sectionGroups.map(([groupName, groupItems], gi) => (
          <div key={groupName} style={{
            background: "var(--surface)",
            border: "1px solid var(--border)",
            borderRadius: "16px",
            padding: "2rem",
            borderTop: `3px solid ${arrowColors[gi % arrowColors.length]}`
          }}>
            <h3 style={{
              fontFamily: "'Playfair Display', serif",
              fontSize: "1.1rem",
              color: "var(--white)",
              textTransform: "uppercase",
              letterSpacing: ".05em",
              marginBottom: "1.2rem",
              paddingBottom: ".8rem",
              borderBottom: "1px solid var(--border)"
            }}>
              {groupName}
            </h3>
            <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
              {groupItems.map(item => (
                <li key={item.id} style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: ".6rem",
                  marginBottom: ".75rem",
                  fontSize: ".9rem",
                  color: "var(--text)",
                  lineHeight: 1.5
                }}>
                  <span style={{
                    color: arrowColors[gi % arrowColors.length],
                    fontSize: "1rem", flexShrink: 0, marginTop: "1px"
                  }}>➤</span>
                  {item.subheading}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
}

function AttractionsSection({ items }) {
  const list = (items || []).filter(a => a.attraction_status === 1);

  const getImg = (img) => {
    if (img && img !== 'default.jpg')
      // return `${API_BASE}/attraction/${img}`;
      return `${BASE_URL}/attraction/${img}`;
    return "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800&q=80";
  };

  if (!list.length) return null;

  return (
    <section className="section">
      <div className="flex-between">
        <div>
          <div className="section-label">Explore</div>
          <h2 className="section-title">Popular <span className="gold">Attractions</span></h2>
        </div>
        <button style={{
          background: "transparent", color: "var(--gold)",
          border: "1px solid var(--gold)", padding: ".5rem 1.4rem",
          borderRadius: "8px", cursor: "pointer",
          fontSize: ".88rem", fontWeight: 600
        }}>
          View All →
        </button>
      </div>
      <div className="attr-grid">
        {list.map(item => (
          <div className="attr-card" key={item.attraction_id}>
            <img src={getImg(item.attraction_img)} alt={item.attraction_name} />
            <div className="attr-overlay" />
            <div className="attr-info">
              <div className="attr-title">{item.attraction_name}</div>
              <div className="attr-desc">{item.attraction_descp}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

function VehicleSlider() {
  const [idx, setIdx] = useState(0);
  const trackRef = useRef(null);
  const containerRef = useRef(null);
  const [cardWidth, setCardWidth] = useState(385);
  const [perView, setPerView] = useState(3);
  const navigate = useNavigate();
  const [vehicles, setVehicles] = useState([]);

  // useEffect(() => {
  //   const API_BASE = "${API_BASE}/api";
  
  //   Promise.all([
  //     fetch(`${API_BASE}/cars`).then(r => r.json()).catch(() => []),
  //     fetch(`${API_BASE}/price`).then(r => r.json()).catch(() => []),
  //   ]).then(([carsRaw, pricesRaw]) => {
  //     const cars = Array.isArray(carsRaw)
  //       ? carsRaw
  //       : Array.isArray(carsRaw?.data) ? carsRaw.data : [];
  
  //     const prices = Array.isArray(pricesRaw)
  //       ? pricesRaw
  //       : Array.isArray(pricesRaw?.data) ? pricesRaw.data : [];
  useEffect(() => {
    Promise.all([
      API.get("/cars").then(r => r.data).catch(() => []),
      API.get("/price").then(r => r.data).catch(() => []),
    ]).then(([carsRaw, pricesRaw]) => {
      const cars   = Array.isArray(carsRaw)   ? carsRaw   : (Array.isArray(carsRaw?.data)   ? carsRaw.data   : []);
      const prices = Array.isArray(pricesRaw) ? pricesRaw : (Array.isArray(pricesRaw?.data) ? pricesRaw.data : []);
      // build map: car_id → lowest price
      const priceMap = {};
      prices.forEach(row => {
        const base = parseFloat(row.price) || 0;
        if (!base) return;
        let min = base;
        if (Array.isArray(row.duration_prices)) {
          row.duration_prices.forEach(slab => {
            const disc = parseFloat(slab.discount) || 0;
            const discounted = base - (base * disc / 100);
            if (discounted < min) min = discounted;
          });
        }
        const cid = row.car_id;
        if (!priceMap[cid] || min < priceMap[cid]) {
          priceMap[cid] = Math.round(min);
        }
      });
  
      // merge price into each car
      const merged = cars.map(car => ({
        ...car,
        price: priceMap[car.car_id] ?? null,
      }));
  
      setVehicles(merged);
    });
  }, []);



  const list = (vehicles || []).filter(v => v.car_dispinhome === 1);
  const cars = list.length ? list : (vehicles || []);

  const gap = 24;

  useEffect(() => {
    const update = () => {
      if (!containerRef.current) return;
      const containerW = containerRef.current.offsetWidth;
      const w = window.innerWidth;
      let pv;
      if (w <= 600)      pv = 1;
      else if (w <= 900) pv = 2;
      else               pv = 3;
      setPerView(pv);
      setCardWidth((containerW - gap * (pv - 1)) / pv);
    };
    update();
    const ro = new ResizeObserver(update);
    if (containerRef.current) ro.observe(containerRef.current);
    return () => ro.disconnect();
  }, []);

  const max     = Math.max(0, cars.length - perView);
  const safeIdx = Math.min(idx, max);
  const prev = () => setIdx(i => Math.max(0, i - 1));
  const next = () => setIdx(i => Math.min(max, i + 1));

  const getImg = (img) => {
    if (img && img !== '')
      // return `${API_BASE}/${img}`;
      return `${BASE_URL}/${img}`;
    return "https://images.unsplash.com/photo-1560958089-b8a1929cea89?w=600&q=80";
  };

  // ── price resolver ──
  const getPrice = (car) => {
    const candidates = [
      car.discount, car.priceperday, car.perdayprice,
      car.price, car.tar_price, car.min_price, car.base_price,
      car.daily_rate, car.rate,
    ];
    for (const v of candidates) {
      const n = parseFloat(v);
      if (!isNaN(n) && n > 0) return n;
    }
    return null;
  };

  const getMeta = (car) => [
    car.car_passgrno    && `👥 ${car.car_passgrno} Seats`,
    car.car_luggno      && `🧳 ${car.car_luggno} Bags`,
    car.car_transmission && `⚙️ ${car.car_transmission}`,
    car.car_airconditionr == 1 && `❄️ A/C`,
  ].filter(Boolean);

  // ── redirect to OurCars with selected car ──
  const handleCardClick = (car) => {
    navigate("/our-cars2", {
      state: {
        car_id:     car.car_id,
        car_name:   car.car_name,
        group_id:   car.group_id,
        group_name: car.group_name,
        price:      getPrice(car),
      }
    });
  };

  if (!cars.length) return null;

  const offset = safeIdx * (cardWidth + gap);

  return (
    <section className="section vehicles-section">
      <div className="flex-between">
        <div>
          <div className="section-label">Our Fleet</div>
          <h2 className="section-title">Available <span className="gold">Vehicles</span></h2>
        </div>
      </div>

      <div ref={containerRef} style={{ overflow: "hidden", marginTop: "3.5rem" }}>
        <div
          ref={trackRef}
          style={{
            display: "flex",
            gap: `${gap}px`,
            transition: "transform .5s ease",
            transform: `translateX(-${offset}px)`,
          }}
        >
          {cars.map(v => {
            const price = getPrice(v);
            return (
              <div
                key={v.car_id}
                className="vehicle-card"
                style={{
                  minWidth: `${cardWidth}px`,
                  width: `${cardWidth}px`,
                  flexShrink: 0,
                  cursor: "pointer",
                }}
                onClick={() => handleCardClick(v)}
              >
                <img
                  src={getImg(v.car_image)}
                  alt={v.image_alt || v.car_name}
                  className="vehicle-img"
                />
                <div className="vehicle-body">
                  <div className="vehicle-badge">{v.cat_name || v.group_name || "Car"}</div>
                  <div className="vehicle-name">{v.car_name}</div>
                  <div className="vehicle-cat">{v.car_brand}</div>
                  <div className="vehicle-meta">
                    {getMeta(v).map((m, i) => <span key={i}>{m}</span>)}
                  </div>
                  {v.car_desc && (
                    <p style={{
                      fontSize: ".8rem", color: "var(--muted)",
                      marginBottom: "1rem", lineHeight: 1.5,
                      display: "-webkit-box", WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical", overflow: "hidden"
                    }}>
                      {v.car_desc}
                    </p>
                  )}
                  <div className="vehicle-footer">
                    {/* ── price display ── */}
                    <div className="vehicle-price">
                      {price
                        ? <><span className="gold" style={{ fontSize: "1.1rem", fontWeight: 700 }}>₹ {price}</span><small style={{ display: "block", color: "var(--muted)", fontSize: ".72rem" }}>per day</small></>
                        : <span style={{ color: "var(--muted)", fontSize: ".85rem" }}>On Request</span>
                      }
                    </div>
                    <button
                      className="vehicle-btn"
                      onClick={(e) => { e.stopPropagation(); handleCardClick(v); }}
                    >
                      Book Now
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Nav */}
      <div className="slider-nav">
        <button className="sl-btn" onClick={prev} disabled={safeIdx === 0}>◀</button>
        {Array.from({ length: max + 1 }).map((_, i) => (
          <button
            key={i}
            className="sl-btn"
            onClick={() => setIdx(i)}
            style={i === safeIdx ? {
              background: "var(--gold)", color: "var(--dark)", borderColor: "var(--gold)"
            } : {}}
          >
            {i + 1}
          </button>
        ))}
        <button className="sl-btn" onClick={next} disabled={safeIdx >= max}>▶</button>
      </div>
    </section>
  );
}

function TestimonialsSection({ items }) {
  const PER_PAGE = 3;
  const [page, setPage] = useState(0);
  const pausedRef = useRef(false);
  const [perPage, setPerPage] = useState(3);

  // Adjust per-page based on screen size
  useEffect(() => {
    const update = () => {
      const w = window.innerWidth;
      if (w <= 600) setPerPage(1);
      else if (w <= 900) setPerPage(2);
      else setPerPage(3);
    };
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  const active = (items || []).filter(
    t => t.testimonial_sts === 1 && t.testimonial_dispinfront === 1
  );
  const list = active.length ? active : (items || []);
  const totalPages = Math.max(1, Math.ceil(list.length / perPage));
  const safeePage = Math.min(page, totalPages - 1);
  const slice = list.slice(safeePage * perPage, safeePage * perPage + perPage);

  const getAvatar = (img) => {
    if (img && img !== 'default.jpg')
      // return `http://localhost:5000/testimonial/${img}`;
      return `${BASE_URL}/testimonial/${img}`;
    return null;
  };

  const getInitials = (name = '') =>
    name.split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase();

  const getStars = (rating) => {
    const r = Math.min(5, Math.max(1, parseInt(rating) || 5));
    return Array.from({ length: 5 }, (_, i) => (
      <span key={i} style={{ color: i < r ? '#EF9F27' : 'rgba(255,255,255,.2)', fontSize: '1rem' }}>★</span>
    ));
  };

  useEffect(() => {
    if (!list.length) return;
    const t = setInterval(() => {
      if (!pausedRef.current) {
        setPage(p => (p + 1) % Math.max(1, totalPages));
      }
    }, 4000);
    return () => clearInterval(t);
  }, [list.length, totalPages]);

  return (
    <section
      className="section"
      style={{ background: "var(--dark2)", borderTop: "1px solid var(--border)" }}
      onMouseEnter={() => { pausedRef.current = true; }}
      onMouseLeave={() => { pausedRef.current = false; }}
    >
      <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "space-between", marginBottom: "2.5rem", flexWrap: "wrap", gap: "1rem" }}>
        <div>
          <div className="section-label">Customer Reviews</div>
          <h2 className="section-title">What Our <span className="gold">Customers Say</span></h2>
        </div>
        <div style={{ display: "flex", gap: "8px" }}>
          <button onClick={() => { setPage(p => (p - 1 + totalPages) % totalPages); pausedRef.current = true; }} style={{
            width: 40, height: 40, borderRadius: "50%",
            border: "1px solid var(--border)", background: "var(--surface)",
            color: "var(--text)", cursor: "pointer", fontSize: "1rem"
          }}>◀</button>
          <button onClick={() => { setPage(p => (p + 1) % totalPages); pausedRef.current = true; }} style={{
            width: 40, height: 40, borderRadius: "50%",
            border: "1px solid var(--border)", background: "var(--surface)",
            color: "var(--text)", cursor: "pointer", fontSize: "1rem"
          }}>▶</button>
        </div>
      </div>

      <div style={{
        display: "grid",
        gridTemplateColumns: `repeat(${perPage}, 1fr)`,
        gap: "1.25rem"
      }}>
        {slice.map((t, i) => (
          <div key={t.testimonial_id ?? i} style={{
            background: "var(--surface)",
            border: i === 0 ? "2px solid var(--gold)" : "1px solid var(--border)",
            borderRadius: "16px", padding: "1.75rem",
            display: "flex", flexDirection: "column", gap: "1rem",
            transition: "border-color .3s"
          }}>
            <div style={{ fontFamily: "'Playfair Display', serif", fontSize: "3rem", lineHeight: 1, color: "var(--gold)", opacity: .6 }}>"</div>
            <p style={{ fontSize: ".9rem", color: "var(--text)", lineHeight: 1.7, margin: 0, flex: 1 }}>
              {t.testimonial_description}
            </p>
            <div style={{ display: "flex", gap: "2px" }}>{getStars(t.rating_id)}</div>
            <div style={{ display: "flex", alignItems: "center", gap: "12px", paddingTop: "1rem", borderTop: "1px solid var(--border)" }}>
              {getAvatar(t.testimonial_img) ? (
                <img src={getAvatar(t.testimonial_img)} alt={t.testimonial_name}
                  style={{ width: 44, height: 44, borderRadius: "50%", objectFit: "cover", border: "2px solid var(--gold)", flexShrink: 0 }} />
              ) : (
                <div style={{
                  width: 44, height: 44, borderRadius: "50%",
                  background: "rgba(201,168,76,.15)", border: "2px solid var(--gold)",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontSize: ".85rem", fontWeight: 700, color: "var(--gold)", flexShrink: 0
                }}>
                  {getInitials(t.testimonial_name)}
                </div>
              )}
              <div>
                <div style={{ fontWeight: 600, fontSize: ".95rem", color: "var(--white)" }}>{t.testimonial_name}</div>
                <div style={{ fontSize: ".8rem", color: "var(--muted)" }}>{t.testimonial_address}</div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div style={{ display: "flex", gap: "6px", justifyContent: "center", marginTop: "2rem" }}>
        {Array.from({ length: totalPages }, (_, i) => (
          <button key={i} onClick={() => { setPage(i); pausedRef.current = true; }} style={{
            width: i === safeePage ? 24 : 8, height: 8,
            borderRadius: i === safeePage ? "4px" : "50%",
            border: "none",
            background: i === safeePage ? "var(--gold)" : "rgba(255,255,255,.2)",
            cursor: "pointer", transition: "all .3s", padding: 0
          }} />
        ))}
      </div>
    </section>
  );
}

function Footer({ data }) {
  if (!data) return null;
  const icons = { facebook:"f", twitter:"𝕏", instagram:"◈", youtube:"▶" };
  return (
    <footer>
      <div className="footer-top">
        <div>
          <div className="footer-brand">Orisnz<span>{data.company?.replace("Orisnz","").split(" ")[0] || "-Fleet"}</span></div>
          <p className="footer-tagline">India's most trusted car rental service — delivering exceptional journeys since 2010.</p>
          <div className="footer-contact">
            <p>📍 <strong>{data.address}</strong></p>
            <p>📞 <strong>{data.phone}</strong></p>
            <p>✉️ <strong>{data.email}</strong></p>
          </div>
          <div className="footer-social">
            {Object.entries(data.social || {}).map(([k,v]) => (
              <a key={k} href={v} className="social-btn" title={k}>{icons[k]||"●"}</a>
            ))}
          </div>
        </div>
        {Object.entries(data.links || {}).map(([col, links]) => (
          <div className="footer-col" key={col}>
            <h4>{col}</h4>
            <ul>{links.map(l => <li key={l}><a href="#">{l}</a></li>)}</ul>
          </div>
        ))}
      </div>
      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} {data.company}. All rights reserved.</p>
        <p>Made with ♥ in India</p>
      </div>
    </footer>
  );
}

// ─── ROOT APP ────────────────────────────────────────────────
export default function App() {
  const { data: settings } = useFetch("/settings","settings");
  const { data: banners }  = useFetch("/banners?limit=100","banners");
  const { data: why }      = useFetch("/sections?limit=100","whychoose");
  const { data: attr }     = useFetch("/attractions?limit=100","attractions");
  const { data: vehicles } = useFetch("/cars?limit=100","vehicles");
  const { data: testis }   = useFetch("/testimonials?limit=100","testimonials");
  const { data: footer }   = useFetch("/footer","footer");
  const { data: carGroups }= useFetch("/cargroup","carGroups");

  const engineType = settings?.engine_type ?? 1;

  return (
    <>
      <style>{css}</style>
      <Navbar siteName={settings?.site_name} />
      <Navbar activePage="Home" siteName={settings?.site_name} />
      <BannerSlider slides={banners || []} />
      {engineType === 1
        ? <BookingEngineHorizontal carGroups={carGroups || []} />
        : <BookingEngineVertical   carGroups={carGroups || []} />
      }
      <WelcomeSection />
      <WhyChooseSection items={why} />
      <AttractionsSection items={attr} />
      <VehicleSlider vehicles={vehicles} />
      <TestimonialsSection items={testis} />
      <Footer data={footer} />
    </>
  );
}